import { useOrgAuthStore } from "@solomon-apps/shared";

/**
 * Query-key segment for the selected client operating context.
 *
 * Every client-scoped query must include this segment directly after its base
 * key: requests resolve the operating-context header dynamically per call
 * (see `orgAuthFetch`), so a cache entry keyed without the context would keep
 * serving issuer A's data after the user switches to issuer B. Keying by
 * context makes a switch fetch fresh data while keeping each context's cache
 * valid for switching back. Prefix invalidations (`["client-positions"]`
 * etc.) are unaffected.
 *
 * `"default"` covers the no-explicit-selection state, where the backend
 * resolves the organization's default context.
 */
export function useClientContextKey(): string {
    return useOrgAuthStore((s) => s.selectedClientContextUuid) ?? "default";
}
